<div style="overflow: hidden;">
    <div class="modal-header">
    <h4 class="modal-title" id="mondalAddCampaignTitle">{{ isEdit? 'Editar' : 'Nuevo ' }} Visto Bueno</h4>
    <!--<button type="button" class="btn-close" mat-dialog-close></button>-->
      <button class="btn-close" (click)="cancelcloseForm()">
       
      </button>
</div>
<div class="modal-body">
    <h6>Ingresa la siguiente información:</h6>
    <form #f="ngForm">
        <div class="row">
            <div class="col mb-3 row">
                <div class="col-sm-6">
                    <mat-form-field class="w-100" appearance="outline">
                        <mat-label>Nombre del Área</mat-label>
                        <input  matInput placeholder="Ej: BEBÉS" name="name" [(ngModel)]="newVobo.area" required>
                        <mat-icon matSuffix>users</mat-icon>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                  <mat-form-field class="w-100" appearance="outline">
                     <mat-label>Dias programados</mat-label>
                     <input  matInput matTooltip="Dias limite en el que el visto bueno tiene para ser aprobado respecto al visto bueno anterior" placeholder="Ej: 2" name="time" [(ngModel)]="newVobo.scheluded_time_days" type="number" required>
                     <mat-icon matSuffix>schelude</mat-icon>
                  </mat-form-field>
                </div>

                <mat-slide-toggle name="optional" [(ngModel)]="newVobo.optional">Es opcional</mat-slide-toggle>

                <mat-form-field class="w-100" appearance="outline">
                    <mat-label *ngIf="!newVobo.is_provider_vobo">Usuarios del area</mat-label>
                    <mat-label *ngIf="newVobo.is_provider_vobo">Permisos de archivo</mat-label>
                    <mat-select [(ngModel)]="newVobo.users" name="users_name" multiple (closed)="clearUserSearch()">
                        <div class="search-option">
                            <div class="search-input-container mat-form-field-outlined">
                                <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                                <input matInput [(ngModel)]="userSearchTerm" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterUsers()" (click)="$event.stopPropagation()" placeholder="Buscar usuario...">
                            </div>
                        </div>
                        <button mat-flat-button (click)="toggleAllUsers()">
                            <mat-icon>library_add</mat-icon>
                            {{ areAllUsersSelected() ? 'Quitar todos' : 'Seleccionar todos' }}
                        </button>
                        <mat-option *ngFor="let user of filteredUsers" [value]="user.id">{{ user.name }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-slide-toggle [disabled]="hasProveedor && !newVobo.is_provider_vobo" name="is_provider_vobo" [(ngModel)]="newVobo.is_provider_vobo">Proveedor</mat-slide-toggle>
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Folmulario de VoBo</mat-label>
                    <mat-select [(ngModel)]="newVobo.vobos" name="nombre_form" multiple (closed)="clearFormSearch()">
                        <div class="search-option">
                            <div class="search-input-container mat-form-field-outlined">
                                <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
                                <input matInput [(ngModel)]="formSearchTerm" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterForms()" (click)="$event.stopPropagation()" placeholder="Buscar formulario...">
                            </div>
                        </div>
                        <button mat-flat-button (click)="toggleAllForms()">
                            <mat-icon>library_add</mat-icon>
                            {{ areAllFormsSelected() ? 'Quitar todos' : 'Seleccionar todos' }}
                        </button>
                        <mat-option *ngFor="let form of filteredForms" [value]="form.id">{{ form.nombre }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="col-12 mb-3">
                    <button mat-stroked-button color="accent" (click)="openAlertsConfig()" [disabled]="totalSelectedVobos === 0">
                        <mat-icon>notification_important</mat-icon>
                        Configurar alertas ({{ configuredAlertsCount }}/{{ totalSelectedVobos }})
                    </button>
                </div>
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nuevo Campo</mat-label>
                    <input matInput placeholder="Ej: VoBo" name="Vobo" [(ngModel)]="itemToAdd">
                    <mat-icon matSuffix>check</mat-icon>
                </mat-form-field>
                <div class="col-4">
                <button mat-flat-button color="primary" (click)="saveFormulario()">
                    <mat-icon>add</mat-icon> Añadir nuevo campo a Formulario
                </button>
                </div>

            </div>
        </div>

    </form>
</div>
<div class="modal-footer">
    <button mat-flat-button (click)="closeForm()" class="bg-success text-white" >Ok <mat-icon>save</mat-icon></button>
</div>
</div>
